export default __webpack_public_path__ + "static/media/Etape1_PremiereManufacture_After_Filtre.78cfcfeb.jpg";